function enableAccordion() {
	let tmpObj = document.getElementsByClassName("accordion");
	for (let i = 0; i < tmpObj.length; i++) {
		tmpObj[i].addEventListener("click", function() {
			this.classList.toggle("active");
			let panel = this.nextElementSibling;
			if (panel.style.maxHeight) {
				panel.style.maxHeight = null;
			} else {
				panel.style.maxHeight = panel.scrollHeight + "px";
			}
		});
	}
}

export default enableAccordion;
